// Initialize Sentry FIRST - before any other imports
import './sentry';
import * as Sentry from "@sentry/react";

// Expose Sentry globally for App.js and other components
window.Sentry = Sentry;

import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<div style={{padding: '50px', textAlign: 'center'}}><h1>Something went wrong</h1><p>Our team has been notified.</p></div>}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
